import { Box, Typography, Avatar, Paper } from '@mui/material';
import { getInitials, formatTime } from './kommentareUtils';

// Eine Chat-Nachricht (eigene rechts, fremde links).
function KommentarBubble({ kommentar: k, isOwnMessage, nutzer }) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: isOwnMessage ? "flex-end" : "flex-start",
                alignItems: "flex-end",
                gap: 1,
            }}
        >
            {!isOwnMessage && (
                <Avatar
                    sx={{
                        width: 32,
                        height: 32,
                        bgcolor: "#3b82f6",
                        fontSize: "0.75rem",
                        flexShrink: 0,
                    }}
                >
                    {getInitials(k.nutzer_info?.vname, k.nutzer_info?.nname)}
                </Avatar>
            )}

            <Box
                sx={{
                    maxWidth: "75%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: isOwnMessage ? "flex-end" : "flex-start",
                }}
            >
                {!isOwnMessage && (
                    <Typography
                        variant="caption"
                        sx={{
                            color: "#93c5fd",
                            mb: 0.5,
                            px: 1,
                            fontWeight: 600,
                        }}
                    >
                        {k.nutzer_info?.vname} {k.nutzer_info?.nname}
                    </Typography>
                )}

                <Paper
                    elevation={2}
                    sx={{
                        px: 2,
                        py: 1.5,
                        background: isOwnMessage
                            ? "linear-gradient(145deg, #3b82f6 0%, #2563eb 100%)"
                            : "linear-gradient(145deg, #1e293b 0%, #0f172a 100%)",
                        border: isOwnMessage
                            ? "none"
                            : "1px solid rgba(59, 130, 246, 0.3)",
                        borderRadius: isOwnMessage
                            ? "16px 16px 4px 16px"
                            : "16px 16px 16px 4px",
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: isOwnMessage ? "#fff" : "#e0f2fe",
                            wordBreak: "break-word",
                        }}
                    >
                        {k.text}
                    </Typography>
                </Paper>

                <Typography
                    variant="caption"
                    sx={{
                        color: "#64748b",
                        mt: 0.5,
                        px: 1,
                        fontSize: "0.7rem",
                    }}
                >
                    {formatTime(k.erstellt_am)}
                </Typography>
            </Box>

            {isOwnMessage && (
                <Avatar
                    sx={{
                        width: 32,
                        height: 32,
                        bgcolor: "#8b5cf6",
                        fontSize: "0.75rem",
                        flexShrink: 0,
                    }}
                >
                    {getInitials(nutzer.vname, nutzer.nname)}
                </Avatar>
            )}
        </Box>
    );
}

export default KommentarBubble;
